import $script from 'scriptjs';

// jQuery plugins
import './globals/jquery';
import './globals/aria.jquery.js';
import 'jquery-trend';
import 'jquery-revealer';

import ThemeEditor from './components/ThemeEditor';
import Sections from './Sections';
import HomeSlideshow from './sections/HomeSlideshow';
import HomeVideo from './sections/HomeVideo';
import HomeTestimonials from './sections/HomeTestimonials';
import HomeInstagram from './sections/HomeInstagram';
import HomeTwitter from './sections/HomeTwitter';
import HomeMap from './sections/HomeMap';
import Cart from './templates/Cart';
import Home from './templates/Home';
import Lookbook from './templates/Lookbook';
import Account from './templates/Account';
import Blog from './templates/Blog';
import Search from './templates/Search';
import Password from './templates/Password';
import ShareWidget from './components/ShareWidget';
import Sidebar from './components/Sidebar';
import Product from './components/Product';
import TagList from './components/TagList';
import RTE from './components/RTE';

export default class Vogue {
  constructor() {
    this.$scripts = $('[data-scripts]');
    this.$html = $('html');

    this._init();
  }

  _init() {
    // Components
    this.shareWidget = new ShareWidget();
    this.tagList = new TagList();
    this.sidebar = new Sidebar();
    this.rte = new RTE();

    // Page Templates
    this.home = new Home();
    this.cart = new Cart();
    this.lookbook = new Lookbook();
    this.product = new Product(this);
    this.account = new Account();
    this.blog = new Blog();
    this.search = new Search();
    this.password = new Password();

    // Theme Editor interactions
    this.themeEditor = new ThemeEditor(this);

    // Theme Sections
    this.sections = new Sections();
    this.sections.register('home-slideshow', section => new HomeSlideshow(section));
    this.sections.register('home-video', section => new HomeVideo(section));
    this.sections.register('home-testimonials', section => new HomeTestimonials(section));
    this.sections.register('home-instagram', section => new HomeInstagram(section));
    this.sections.register('home-twitter', section => new HomeTwitter(section));
    this.sections.register('home-map', section => new HomeMap(section));

    if(this.$html.hasClass('ie9')) {
      this._ie9Helpers();
    }
  }

  _ie9Helpers() {
    $script(this.$scripts.data('placeholder-ie9'), () => {
      $('input, textarea').placeholder();
    });
  }
}

new Vogue();
